








































































































































import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import Add from '@/views/system/settings/dict/unit/add.vue';
import DictType from '@/views/system/settings/dict/dictType.vue';
import { dictServe } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { PagingUnit, CollapseTransition, Add, DictType },
  mixins: [TableStripe],
})
export default class User extends Vue {
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };

  private loading: any = false; // 表格加载
  private vibs: any = false; // 编辑页展示
  private formShow = false; // 是否显示搜索表单内容
  private dictTypeVibs: any = false; // 是否显示编辑页
  private total = 0; // 数据总共多少条
  private editRoleFlag: any = 1; // 控制显示 编辑 页面
  private row: any = {}; // 控制显示 编辑 页面

  // private systemProfessionOptions: any = [
  //   {
  //     value: 1,
  //     label: '是',
  //   },
  //   {
  //     value: 2,
  //     label: '否',
  //   },
  // ];
  //
  // private stateOptions: any = [
  //   {
  //     value: 1,
  //     label: '正常',
  //   },
  //   {
  //     value: 0,
  //     label: '停用',
  //   },
  // ];

  // 表单数据对象
  formData: any = {
    name: '', // 字典名称
    // professionName: '', // 岗位名称
    // professionType: '', // 岗位分类
    // systemProfession: '', // 岗位分类
    // state: '', // 状态
  };

  // 表单数据对象
  form: any = {
    id: '',
    name: '', // 字典名称
    description: '', // 字典描述
  };

  // table 数据对象
  tableData: any = [];

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮触发，隐藏或显示搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */

  private created() {
    this.getDictData();
  }

  private getDictData() {
    dictServe
      .sysDictList({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        name: this.formData.name ? this.formData.name : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  isShowForm() {
    this.formShow = !this.formShow;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击新增或编辑按钮触发，跳转到新增或编辑页面.
   * @param1 暂无
   * @returns 暂无
   */
  addAndEditProfession(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    this.queryDataForm.pageNo = 1;
    this.getDictData();
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * 分页回调事件
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getDictData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置搜索表单内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    this.formData.name = '';
    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = 10;
    this.getDictData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param 点击字典类型 - 展示字典类型列表
   * @returns 返回值描述
   */
  dictTypeList(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 3; // 进入编辑页面
  }

  // /**
  //  * @todo 后期需要优化的部分
  //  * @desc 函数描述
  //  * @param 点击停用字典类型
  //  * @returns 返回值描述
  //  */
  // stopDictType(id: any) {
  //   this.$confirm('确认要停用该字典类型吗？', '信息', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     type: 'warning',
  //     customClass: 'box--msg',
  //   })
  //     .then(() => {
  //       this.$message({
  //         type: 'success',
  //         message: '停用成功!',
  //       });
  //     })
  //     .catch(() => {
  //       this.$message({
  //         type: 'info',
  //         message: '已取消停用！',
  //       });
  //     });
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param 删除接口
   * @returns 返回值描述
   */
  deleteData(id: any) {
    this.$confirm('确认要删除该字典类型吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        dictServe
          .deleteDictData(id)
          .then((res: any) => {
            this.getDictData(); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除！',
        });
      });
  }

  private handleMenuEditResponse() {
    this.editRoleFlag = 1;
    this.getDictData();
  }

  private handleDictTypeResponse() {
    this.editRoleFlag = 1;
    this.getDictData();
  }
}
